import styled from 'styled-components';

interface CardProps {
    isDanger?: boolean;
}

export const CardWrapper = styled.div<CardProps>`
  background-color: ${({ isDanger, theme }) => {
    if (isDanger) return theme.mode === 'dark' ? '#3f1d1d' : '#ffe5e5';
    return 'transparent';
  }};
  ${({ isDanger, theme }) => isDanger
    && `
      border: 1px solid ${theme.colors.danger[500]};
      border-radius: 6px;
      padding: 2px 10px;
    `}
`;

export const TileWrapper = styled.div`
  padding:7.5px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;

export const TileDescription = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  max-width: 600px;
    gap: 15px;
  h3 {
    font-size: 14px;
    font-weight: 500;
    margin: 0;
      color: ${({ theme }) => theme.colors.text.primary};
  }

`;

export const TileIco = styled.i<CardProps>`
  margin-right: 16px;
  margin-top: 3px;
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 6px;
border-color: ${({ isDanger, theme }) => (isDanger ? theme.colors.border.primary : theme.colors.text.primary)};
background-color: ${({ isDanger, theme }) => {
    if (isDanger) return theme.mode === 'dark' ? '#3f1d1d' : '#ffe5e5';
    return 'transparent';
  }};
${({ isDanger }) => isDanger && `
  border-radius: 6px;
  padding: 5px 10px;
`}
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TileParagraph = styled.div`
  margin: 0;
    padding: 0;
  font-size: 13px;
  font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
`;

export const TileActionBlock = styled.span`
  display: flex;
  max-width: 200px;
`;
